<template>
  <div class="block" v-if="planList.length">
    <div class="block-header">
      <span>医术咨询/预备方案</span>
      <span class="title-other"
        >（根据本次和上次就诊的对比情况向患者解释说明）</span
      >
    </div>
    <div class="black-body">
      <utabs :list="planList" v-model="tabValue" type="utabs-type2" />
      <div class="con">{{ con }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    planList() {
      return this.medicalExpertisePlanDrug.map((i, index) => {
        return {
          label: i.planName,
          value: index,
        };
      });
    },
    con() {
      let item = this.medicalExpertisePlanDrug[this.tabValue];
      return item ? item.planExplain : "";
    },
  },
  data() {
    return {
      tabValue: 0,
      medicalExpertisePlanDrug: [],
    };
  },
  methods: {
    getMedicalExpertisePlanDrug() {
      this.request
        .post("/zhbusiness/getMedicalExpertisePlanDrug", {
          diseaseCode: this.info.diagnosticId2, //	病种Code
          patientCode: this.info.patientCode, //	患者编码
        })
        .then((res) => {
          this.medicalExpertisePlanDrug = res.result;
          this.$emit("getDataSuccess", res.result);
        });
    },
  },
  created() {
    this.getMedicalExpertisePlanDrug();
  },
};
</script>

<style lang="scss" scoped>
.utabs {
  line-height: 26px;
}
.title-other {
  font-size: 13px;
  font-weight: normal;
}
</style>